import type { DenormalizedBlockEntity } from '@web/types';

import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import PageStructureActions from './page-structure.actions';

@Injectable()
export class PageStructureFacade {
    private readonly store = inject(Store);

    public setPageStructure(structure: DenormalizedBlockEntity[]): void {
        this.store.dispatch(PageStructureActions.setPageStructure({ structure }));
    }
}
